export default "__VITE_ASSET__Dj5Awd5Z__"